import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '@shared/services/theme.service';

@Component({
    selector: 'app-theme-toggle',
    standalone: true,
    imports: [CommonModule],
    template: `
    <button 
      class="theme-toggle-btn"
      (click)="themeService.toggleTheme()"
      [attr.aria-label]="themeService.isDarkMode() ? 'Switch to light mode' : 'Switch to dark mode'"
      [attr.title]="themeService.isDarkMode() ? 'Zu hellem Modus wechseln' : 'Zu dunklem Modus wechseln'"
    >
      <!-- Sun icon (shown in dark mode) -->
      <svg 
        *ngIf="themeService.isDarkMode()" 
        class="theme-icon sun-icon"
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        stroke-width="2"
      >
        <circle cx="12" cy="12" r="5"/>
        <line x1="12" y1="1" x2="12" y2="3"/>
        <line x1="12" y1="21" x2="12" y2="23"/>
        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
        <line x1="1" y1="12" x2="3" y2="12"/>
        <line x1="21" y1="12" x2="23" y2="12"/>
        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
      </svg>
      
      <!-- Moon icon (shown in light mode) -->
      <svg 
        *ngIf="themeService.isLightMode()" 
        class="theme-icon moon-icon"
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        stroke-width="2"
      >
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
      </svg>
    </button>
  `,
    styles: [`
    .theme-toggle-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      padding: 8px;
      background: var(--bg-hover);
      border: 1px solid var(--border-color);
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s ease;
      color: var(--text-secondary);
    }
    
    .theme-toggle-btn:hover {
      background: var(--accent-light);
      border-color: var(--accent);
      color: var(--accent);
      transform: scale(1.05);
    }
    
    .theme-toggle-btn:active {
      transform: scale(0.95);
    }
    
    .theme-icon {
      width: 20px;
      height: 20px;
    }
    
    .sun-icon {
      color: #fbbf24; /* Yellow for sun */
    }
    
    .moon-icon {
      color: #6366f1; /* Indigo for moon */
    }
  `]
})
export class ThemeToggleComponent {
    readonly themeService = inject(ThemeService);
}
